import { FOODS_TAB_INDEX, PlacesFoodsTab } from "./PlacesFoodsTabs/PlacesFoodsTabs.helpers";

/**
 * Translates the legacy `/places?tabIndex=` value into the US Chains `?tab=`
 * equivalent. Anything that isn't the Foods index — including an absent or
 * unparseable value (`NaN`) — lands on Places, which is the US Chains default.
 */
export function getRedirectTargetTab(tabIndex: number): PlacesFoodsTab {
    return tabIndex === FOODS_TAB_INDEX ? "foods" : "places";
}
